import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { registerSessionExpiredHandler } from '../services/authSession';

const AuthContext = createContext(null);

const createInitialUserState = () => ({
    id: null,
    userUUID: '',
    token: '',
    organisationId: null,
    organisationName: '',
    name: '',
    email: '',
    picture: '',
    role: '',
    isActive: false,
    twoFactorEnabled: false,
    organisations: [],
});

export const AuthProvider = ({ children }) => {
    const [authenticated, setAuthenticated] = useState(false);
    const [user, setUser] = useState(createInitialUserState);

    const logout = useCallback(() => {
        setUser(createInitialUserState());
        setAuthenticated(false);
    }, []);

    useEffect(() => {
        return registerSessionExpiredHandler(logout);
    }, [logout]);

    return (
        <AuthContext.Provider
            value={{
                authenticated,
                setAuthenticated,
                user,
                setUser,
                logout,
            }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};